import React from 'react'

export const FormEnvironmentContext = React.createContext({})